<ci-sub-header title="Current and previous imports"></ci-sub-header>

<div class="upload-field">
  <coin-v2-button
    [type]="'primary'"
    [icon]="'upload'"
    [iconPos]="'right'"
    [text]="'Upload'"
    (click)="openUploadPopup()"></coin-v2-button>
</div>
<ci-simple-table
  [header]="selectedTableHeaders"
  [service]="selectedTableService"
  [serverPaginated]="true"
  [serverside]="true"
  [presetQueryParams]="queryParameters$ | async"
  [isExpectedToChange]="isExpectedToChange"
  [updaterIntervalInMs]="updaterIntervalInMs">
  <ng-template
    #columns
    let-item>
    <ng-container>
      <div class="content-column">
        @if (item) {
          <div class="row">
            @if (!isExpectedToChange(item.state)) {
              <i
                class="edit-button material-icons"
                (click)="loadSummary(item)">
                {{ item.state === 'Staged' ? 'edit' : 'visibility' }}
              </i>
            } @else {
              @if (item.message) {
                <p
                  #tooltip="matTooltip"
                  matTooltip="{{ item.message.split('/')[2] }}"
                  matTooltipPosition="below">
                  {{ getProgressPercentage(item.message) }} %
                </p>
              }
              @if (!item.message && isStaging(item)) {
                <i
                  class="edit-button in-progress material-icons"
                  (click)="loadSummary(item)">
                  downloading
                </i>
              }
              @if (!item.message && isPending(item)) {
                <i
                  class="edit-button in-progress material-icons"
                  matTooltip="Open PopUp"
                  (click)="openJumpPopup(item)">
                  double_arrow
                </i>
              }
              @if (!item.message && isPostStaging(item)) {
                <i
                  class="edit-button in-progress material-icons"
                  (click)="loadSummary(item)">
                  publish
                </i>
              }
            }
          </div>
        }
      </div>

      <div class="content-column">
        @if (item) {
          <div class="row">
            <p [class.error]="item.state === 'Failed'">
              {{ item.fileName | fileName }}
            </p>
          </div>
        }
      </div>

      <div class="content-column">
        <div class="ps-wrapper">
          @if (item) {
            <div>
              <p class="ps ps--finalized">{{ item.state }}</p>
            </div>
          }
        </div>
      </div>

      <div class="content-column">
        @if (item) {
          <div class="row">
            <mat-icon>calendar_today</mat-icon>
            <p [class.error]="item.state === 'Failed'">
              {{ item.uploadedAt | date: 'MMM d, y' }}
              <br />
              {{ item.uploadedAt | date: '(HH:mm, z)' : 'UTC' }}
            </p>
          </div>
        }
      </div>

      <div class="content-column">
        @if (item && item.fileType) {
          <div>
            <p [class.error]="item.state === 'Failed'">
              {{ item.fileType.displayedName }}
            </p>
          </div>
        }
      </div>

      <div class="content-column">
        <div>
          @if (item && item.stats && item.stats.totalDatasets >= 0) {
            <p [class.error]="item.state === 'Failed'">{{ item.stats.totalDatasets | number: '1.0' }} datasets</p>
          }
          <p [class.error]="item.state === 'Failed'">
            {{ item.uploadSizeInBytes | fileSize }}
          </p>
        </div>
      </div>

      <div
        class="content-column"
        [class.pending]="isNotReadyState(item)">
        @if (item && item.stats && item.stats.changedDatasets >= 0) {
          <div>
            <p [class.error]="item.state === 'Failed'">
              {{ item.stats.changedDatasets | number: '1.0' }} datasets ({{
                item.stats.changedDatasets | percentage: item.stats.totalDatasets
              }}
              of total)
              <br />
              {{ item.stats.deltaSizeInBytes | fileSize }}
            </p>
          </div>
        }
      </div>

      <div
        class="content-column"
        [class.pending]="isNotReadyState(item)">
        @if (item && item.stats && item.stats.invalidDatasets >= 0) {
          <div>
            <p [class.error]="item.state === 'Failed'">
              {{ item.stats.invalidDatasets | number: '1.0' }} datasets ({{
                item.stats.invalidDatasets | percentage: item.stats.changedDatasets
              }}
              of changed)
            </p>
          </div>
        }
      </div>

      <div
        class="content-column"
        [class.pending]="isNotReadyState(item)">
        @if (item?.decision?.decidedBy) {
          <div class="row">
            <i class="material-icons cr-icon">person</i>
            <p [class.error]="item.state === 'Failed'">
              {{ getNameFromDecision(item.decision) }}
              <br />
              (GID: {{ item.decision?.decidedBy?.gid }})
            </p>
          </div>
        }
      </div>
    </ng-container>
  </ng-template>
  <ng-template #noData>
    <p>no data</p>
  </ng-template>
</ci-simple-table>
